module.exports = __webpack_public_path__ + "img/title-left-line.b8b76bfd.png";